<template>
  <div
    class="rounded-md bg-white border dark:bg-neutral-700 dark:border-neutral-600 shadow-sm flex flex-col p-3 group w-full"
    ref="card">
    <NtSpacing compact>
      <div>
        <div class="flex justify-between">
          <h4 class="text-black dark:text-white font-semibold">
            <i v-if="!notification.read_at" class="fa-sharp fa-circle text-accent-500 dark:text-accent-600 text-xs"></i>
            {{ notification.data.title }}
          </h4>

          <button
            type="button"
            class="md:hidden group-hover:flex w-6 h-6 items-center justify-center relative rounded-md bg-white dark:bg-neutral-700 text-neutral-400 hover:text-neutral-500 dark:hover:text-white dark:ring-offset-neutral-800 focus:outline-hidden focus:ring-2 focus:ring-accent-500 focus:ring-offset-2"
            @click="dismiss">
            <span class="absolute -inset-2.5" />
            <span class="sr-only">Dismiss</span>
            <i class="fa-sharp fa-times fa-fw" aria-hidden="true"></i>
          </button>
        </div>
        <p class="my-1 text-xs uppercase text-neutral-500 dark:text-neutral-400">
          {{ $filters.datetime(notification.created_at) }}
          <span v-if="notification.office_id">| {{ officeName || 'Unknown Office' }}</span>
        </p>
      </div>

      <p class="text-sm">{{ notification.data.description }}</p>

      <div v-if="notification.data.module" class="flex justify-end">
        <NtButton level="primary" :icon="notification.data.icon" :disabled="!linkRoute" @click="viewDetail">
          {{ notification.data.label }}
        </NtButton>
      </div>
    </NtSpacing>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'
import NtButton from '../general/NtButton.vue'
import NtSpacing from '../general/NtSpacing.vue'
import { mapActions, mapState } from 'pinia'
import { useSystemStore } from '@/stores/system'
import { useNotificationStore } from '@/stores/notifications'

export default {
  components: { NtSpacing, NtButton },
  emits: ['close'],
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      observer: null,
      readTimer: null
    }
  },
  mounted() {
    if (!this.notification.read_at) {
      this.observer = new IntersectionObserver(this.inView, {
        rootMargin: '0px',
        thresholds: [0.1, 1.0]
      })
      this.observer.observe(this.$refs.card)
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  computed: {
    ...mapState(useSystemStore, ['hub']),
    ...mapState(useAuthStore, ['authOffices', 'selectedOffice']),
    officeName() {
      const office = this.authOffices.find((o) => o.id === this.notification.office_id)
      if (!office) {
        return
      }

      return office?.name
    },
    linkRoute() {
      if (!this.notification.data.module) {
        return null
      }

      return this.$routeToModule(this.notification.data.module, this.notification.data.route_params)
    }
  },
  methods: {
    ...mapActions(useNotificationStore, ['deleteNotification', 'markNotificationAsRead']),
    ...mapActions(useAuthStore, ['switchOffice']),
    async viewDetail() {
      const id = this.notification.id
      if (this.notification.office_id && this.notification.office_id !== this.selectedOffice.id) {
        await this.switchOffice(this.notification.office_id)
      }

      this.$router.push(this.linkRoute)
      this.$emit('close')
      this.deleteNotification(id)
    },
    dismiss() {
      const id = this.notification.id
      this.deleteNotification(id)
    },
    inView(e) {
      clearTimeout(this.readTimer)

      if (e[0].isIntersecting) {
        this.readTimer = setTimeout(() => {
          const id = this.notification.id
          this.markNotificationAsRead(id)
        }, 3000)
        this.observer.disconnect()
        return
      }
    }
  }
}
</script>
